module.exports = __webpack_public_path__ + "static/media/SDG.7853ed6b.svg";